<div class="frontpage-widget cover-image-mose-gray">
  <div class="whitebox gray">
    <div class="container">
      <p class="text-muted">RISIKOVURDERING
        <i class="fa fa-chevron-right"></i>
      </p>
      <h2 i18n>Dine lokaliteter</h2>
      <p i18n>Dine risikovurderinger er inddelt i lokaliteter. Vælg en lokalitet eller opret en ny.</p>
    </div>
  </div>
</div>
<div class="container">
  <div class="row mt-3" >
    <div class="col-sm-12 col-lg-12">
      <div>
        <div class="vd-main-search-bar no-searchresults">
          <input type="text" id="searchInput" [(ngModel)]="searchText" aria-describedby="searchinput"
                 placeholder="Søg lokalitetsnummer, navn, forureningsstof..."
                 (keydown.enter)="onKeydown($event)">
          <div>
            <button class="btn btn-secondary" (click)="onSearch()">SØG
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-sm-12 col-lg-12">
      <button class="btn btn-primary" data-toggle="modal" data-target="#createLocationModal" (click)="openCreateLocation()"><i class="fa fa-plus-circle fa-lg"></i> Opret ny lokalitet</button>
    </div>
  </div>

  <div class="row mt-5 vd-fade" *ngIf="hasLocations">
    <div class="col-sm-12 col-lg-12">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Lokalitetsnr.</th>
            <th>Navn</th>
            <th>Status</th>
            <th>Faktor
              <span class="text-muted">(alvorligste)</span>
            </th>
            <th>Forureningsstof</th>
            <th>Koncentration</th>
            <th>Sagsbehandler</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let location of searchResults" [routerLink]="['/riskassessment/location-details', location.id]">
            <td>{{location.number}}</td>
            <td>{{location.name}}</td>
            <td>
              <span class="fa-stack risk-indicator" [ngClass]="{'risk-computed':(location.riskAssessmentStatus==riskAssessmentStatus.Risk && location.calculationType != highestRiskCalculationType.Screening), 'risk-screening':(location.riskAssessmentStatus==riskAssessmentStatus.Risk && location.calculationType == highestRiskCalculationType.Screening), 'no-risk-computed':(location.riskAssessmentStatus==riskAssessmentStatus.NoRisk && location.calculationType != highestRiskCalculationType.Screening), 'no-risk-screening':(location.riskAssessmentStatus==riskAssessmentStatus.NoRisk && location.calculationType == highestRiskCalculationType.Screening)}">
                <span class="icon"></span>
              </span>
              <span [ngSwitch]="location.riskAssessmentStatus">
                <span *ngSwitchCase="riskAssessmentStatus.Risk">
                  <b>Risiko</b>
                </span>
                <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
              </span>
            </td>
            <td>
              <span [ngSwitch]="location.riskAssessmentStatus">
                <span *ngSwitchCase="riskAssessmentStatus.Risk">
                  <b>{{location.factor}}</b>
                </span>
                <span *ngSwitchCase="riskAssessmentStatus.NoRisk">{{location.factor}}</span>
              </span>
            </td>
            <td>{{location.pollutant}}</td>
            <td>{{location.concentration}} μg/L</td>
            <td>
              <i class="fa fa-user"></i> {{location.caseWorker?.name}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="text-center mt-5" *ngIf="!hasLocations && hasSearched" >
    <div class="bg-light rounded p-5">
      <h5 class="text-muted">Du har ingen lokaliteter <i class="fa fa-map-marker fa-lg"></i></h5>
      <p class="text-muted">Start med at oprette en lokalitet:</p>
      <button class="btn btn-primary mt-3" data-toggle="modal" data-target="#createLocationModal" (click)="openCreateLocation()"><i class="fa fa-plus-circle fa-lg"></i> Opret lokalitet</button>
    </div>
  </div>
</div>

<div class="modal fade" id="createLocationModal" tabindex="-1" role="dialog"
     aria-labelledby="createLocationModal" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <form (ngSubmit)="createLocation()" ngNativeValidate autocomplete="off">
                <div class="modal-body pt-5 px-5 pb-3">
                    <h5 i18n>Opret ny lokalitet</h5>
                    <p class="text-muted"> Lokaliteten vil kun være synlig for dig og din organisation.</p>

                    <div class="form-group pt-2">
                        <label for="newLocationNumber">Lokalitetsnummer:</label>
                        <input class="form-control  text-input" name="newLocationNumber" placeholder="Indtast et unikt lokalitetsnummer.."
                               [(ngModel)]="newLocationNumber" required />
                    </div>

                    <div class="form-group">
                        <label for="newLocationName">Lokalitetsnavn:</label>
                        <input class="form-control  text-input" name="newLocationName" placeholder="Indtast lokalitetens navn, f.eks.adresse..."
                               [(ngModel)]="newLocationName" required />
                    </div>

                    <div *ngIf="newLocationErrorMsg">
                        <p class="text-danger"><span>*</span> {{ newLocationErrorMsg }}</p>
                    </div>

                    <div class="mb-4 mt-4 text-right">
                        <button type="button" class="btn btn-secondary" id="modalCloseButton" data-dismiss="modal" (click)="closeCreateLocationForm()">Fortryd</button>
                        <button type="submit" class="btn btn-dark ml-2"><i class="fa fa-check"></i> Opret</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>